import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { AuthProvider } from "@/lib/auth";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { TrustProvider } from "@/components/trust/TrustProvider";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import Term from "@/pages/Term";
import Product from "@/pages/Product";
import Search from "@/pages/Search";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import QuizPage from "@/pages/QuizPage";
import ParfumQuiz from "@/pages/ParfumQuiz";
import TopFormules from "@/pages/TopFormules";
import MyGlossary from "@/pages/MyGlossary";

function App() {
  return (
    <AuthProvider>
      <TrustProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/categorie/:slug" element={<Category />} />
              <Route path="/terme/:slug" element={<Term />} />
              <Route path="/glossaire/:slug" element={<Term />} />
              <Route path="/produit/:slug" element={<Product />} />
              <Route path="/recherche" element={<Search />} />
              <Route path="/quiz" element={<QuizPage />} />
              <Route path="/quiz-parfum" element={<ParfumQuiz />} />
              <Route path="/top-formules" element={<TopFormules />} />
              <Route path="/mon-glossaire" element={<MyGlossary />} />
              <Route path="/admin/login" element={<Login />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <Admin />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Layout>
        </BrowserRouter>
      </TrustProvider>
    </AuthProvider>
  );
}

export default App;
